




















import { DocumentReviewer } from "@/types/document/documentReviewer";
import Vue from "vue";
import DocumentToolbarAction from "../DocumentToolbarAction.vue";
import ZenyaDialog from "@/components/dialogs/ZenyaDialog.vue";
import DocumentInstructions from "@/components/modules/document/DocumentInstructions.vue";
import storeHelper from "@/store/store-helper";
import Utils from "@/utils";
export default Vue.extend({
    components: { DocumentToolbarAction, ZenyaDialog, DocumentInstructions },
    name: "ShowDocumentReviewInstructionsAction",
    props: {
        reviewer: Object as () => DocumentReviewer,
        enable: Boolean,
        isButton: Boolean
    },
    data: function () {
        return {
            showReviewInstructionsDialog: false,
            suppressInstructions: false
        };
    },
    watch: {
        showReviewInstructionsDialog: function (newValue: boolean) {
            //do this only on dialog close
            if (!newValue) Utils.updateReviewRoundDescriptionReadByUser(this.reviewer.round.review_template_round_id, this.suppressInstructions);

            storeHelper.siteStore.setIsDialogDisplayed(this.showReviewInstructionsDialog);
        }
    },
    methods: {
        onSuppressChanged(value: boolean): void {
            this.suppressInstructions = value;
        },
        setShowReviewInstructionsDialog(): void {
            this.showReviewInstructionsDialog = true;
        }
    },
    created(): void {
        this.suppressInstructions = !this.reviewer.round.show_instruction_for_current_user;
    }
});
